export default __webpack_public_path__ + "static/terran_collective_logo_blue-daab3c71f9b8012b567a0b4588f47f4c.svg";